module.exports = __webpack_public_path__ + "img/two_banner_bg2.dca5fd8e.jpg";